import {
    Modal,
    ModalContent,
    ModalBody,
    ModalFooter,
    useDisclosure,
    Button,
    ModalHeader,
} from "@nextui-org/react";

import { getOneFrame } from "../../api-route/frame";
import { BaseURL } from "../../config/axios";

import { useEffect, useState } from "react";

export default function FrameDetail({ id }) {
    const { isOpen, onOpen, onOpenChange } = useDisclosure()
    const [frame, setFrame] = useState()

    useEffect(() => {
        if (isOpen) {
            const get = async () => {
                const Frames = await getOneFrame(id);
                setFrame(Frames ? Frames : {})
            }
            get()
        }
    }, [isOpen])


    return (
        <>
            <Button onPress={onOpen} size="sm" className="bg-primary text-white">توضیحات</Button>

            {<Modal isOpen={isOpen} hideCloseButton={true} scrollBehavior={'inside'} onOpenChange={onOpenChange} size="5xl">
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader dir="rtl" />
                            <ModalBody dir="rtl">
                                <div className="text-center mb-6">
                                    <Button onClick={onClose} className="bg-purple-700 text-white">
                                        بازگشت
                                    </Button>
                                </div>

                                <div className="text-center">
                                    <h2 className="text-3xl font-bold mb-2">{frame?.title}</h2>
                                    <p className="text-sm text-gray-600 mb-4">
                                        عرض : {frame?.width} • قیمت : {frame?.price}
                                    </p>
                                </div>

                                <div className="grid grid-cols-1 gap-6">
                                    <div className="">
                                        <p className="text-justify text-gray-700">
                                            {frame?.body}
                                        </p>
                                    </div>
                                    <div className="flex justify-center">
                                        <img width={100} height={100}
                                            src={BaseURL + (frame?.part_frame_image.path || frame?.full_frame_image.path)}
                                            alt={frame?.title}
                                            title={frame?.id}
                                            className="rounded shadow-lg max-w-full"
                                        />
                                    </div>
                                </div>

                                <div className="text-center mt-6">
                                    <Button onClick={onClose} className="bg-purple-700 text-white">
                                        بازگشت
                                    </Button>
                                </div>
                                <p>{frame?.id}</p>
                            </ModalBody>

                            <ModalFooter>
                                <Button variant="light" onClick={onClose}>
                                    بستن
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>}
        </>
    );
}
